import { BaseMany, BaseOne } from '@cnx-saas/common';
import { ArticleEmbedded } from './Article';
import { Load } from './Load';
import { Location } from './Location';

export enum OrderType {
  PICKUP = 'PICKUP',
  DELIVERY = 'DELIVERY',
}
export enum OrderStatus {
  UNMATCHED = 'UNMATCHED',
  MATCHED = 'MATCHED',
  PARTIAL = 'PARTIAL',
}

export type OrderArticle = {
  article: ArticleEmbedded;
  totalQuantity: number;
  totalLoadingMillimeter: number;
  totalWeightInKg: number;
  deadline?: Date;
};

export type OrderInput = {
  externalReference?: string;
  deadline?: Date;
  type: OrderType;
  location: Location;
  articles: OrderArticle[];
  customerOrderReference?: string;
  customerComment?: string;
  internalComment?: string;
};

export type Order = BaseOne &
  OrderInput & { tenantId: string; loads?: Load[]; status: OrderStatus };

export type Orders = BaseMany<Order>;

export type OrderImport = {
  externalReference: string;
  type: OrderType;
  locationExternalReference: string;
  createdAt?: Date;
  deadline?: Date;
  articleExternalReference: string;
  articleName: string;
  articleTotalQuantity: number;
  customerOrderReference?: string;
  customerComment?: string;
  internalComment?: string;
};
